import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, tap } from 'rxjs';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';
import { DeleteConfirmComponent } from '~app/app/~shared/components/modals/delete-confirm/delete-confirm.component';
import { MEDIA_TYPES } from '~app/app/~shared/constants/global.constants';
import { ChannelService } from '~app/app/~shared/services/channel.service';
import { DialogService } from '~app/app/~shared/services/dialog.service';
import { ResourceFacade } from '~app/app/~store/facades/resource.facade';
import { Channel } from '~core/models/channel.models';
import { ChannelCreationDialogComponent } from '../../modals/channel-creation-dialog/channel-creation-dialog.component';
import { ChannelDetailsComponent } from '../channel-details/channel-details.component';
@Component({
  selector: 'channel-list-datatable',
  standalone: false,
  templateUrl: './channel-list-datatable.component.html',
  styleUrl: './channel-list-datatable.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChannelListDatatableComponent extends BaseComponent {
  private _dialogService = inject(DialogService);
  private _channelService = inject(ChannelService);
  private _resourceFacade = inject(ResourceFacade);

  channels = input<Channel[]>([]);
  mediaTypes = MEDIA_TYPES;

  displayedColumns: string[] = ['name', 'country', 'mediaType', 'actions'];

  onRowClick(channels: Channel): void {
    const dialogRef = this._dialogService.open({
      component: ChannelDetailsComponent,
      config: {
        panelClass: ['mat-dialog-custom', 'w-[600px]'],
        backdropClass: ['bg-black/50'],
        disableClose: false,
        maxWidth: '600px'
      }
    });
    dialogRef.componentRef?.setInput('channels', channels);
  }

  openEditDialog(channel: Channel): void {
    const dialogRef = this._dialogService.open({
      component: ChannelCreationDialogComponent,
      fullscreen: true
    });

    dialogRef.componentRef?.setInput('channel', channel);
  }

  openDeleteDialog(channel: Channel): void {
    const delete$ = this._channelService.remove(channel.id);
    const dialogRef = this._dialogService.open({
      component: DeleteConfirmComponent,
      config: {
        panelClass: ['mat-dialog-custom'],
        disableClose: true
      }
    });

    dialogRef.componentInstance.removeObservable$ = delete$;
    dialogRef.componentRef?.setInput(
      'title',
      `Voulez-vous supprimer le support "${channel.name}" ?`
    );
    dialogRef
      .afterClosed()
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        filter(Boolean),
        tap({
          next: () => {
            this._resourceFacade.getData({ refresh: true });
            this._snackbarService.open({
              text: 'Support supprimé',
              type: 'success'
            });
          }
        })
      )
      .subscribe();
  }
}
